import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Standings from './Standings';
import Matches from './Matches';

function TeamDetail({ seasonId }) {
  const { teamId } = useParams();
  const navigate = useNavigate();
  const [team, setTeam] = useState(null);
  const [contacts, setContacts] = useState([]);

  // Efekt pro změnu titulku stránky
  useEffect(() => {
    if (team && team.name) {
      document.title = `${team.name} | Posázavská liga`;
    } else {
      document.title = 'Posázavská liga';
    }

    // Funkce pro vyčištění, která se zavolá při odmontování komponenty
    return () => {
      document.title = 'Posázavská liga';
    };
  }, [team]); // Spustí se, když se změní objekt team

  useEffect(() => {
    if (!seasonId || !teamId) return;
    fetch(`/api/teams?season_id=${seasonId}`)
      .then(res => res.json())
      .then(data => {
        setTeam(data.find(t => t.id === Number(teamId)));
      });
    fetch(`/api/teams/${teamId}/contacts`)
      .then(res => res.json())
      .then(data => setContacts(Array.isArray(data) ? data : []));
  }, [seasonId, teamId]);

  if (!team) return <div>Načítání…</div>;

  return (
    <div className="container py-4">
      <div className="card mx-auto shadow-sm mb-4" style={{maxWidth: 900}}>
        <div className="card-body">
          <div className="d-flex flex-column align-items-center gap-3 mb-4">
            {team.logo && (
              <img
                src={`/logos/${team.logo.replace(/^logos[\\/]/, '')}`}
                alt={team.name}
                className="rounded bg-light border"
                style={{height:96, width:96, objectFit:'contain'}}
              />
            )}
            <h2 className="mb-0">{team.name}</h2>
          </div>
          <div className="mb-4">
            <strong>Kontaktní osoby:</strong>
            <ul className="list-group list-group-flush mt-2 mb-0">
              {contacts.length === 0 && <li className="list-group-item text-muted">Žádné kontaktní osoby</li>}
              {contacts.map(c => (
                <li key={c.id} className="list-group-item">
                  <div><strong>{c.name}</strong></div>
                  {c.phone && <div>Tel: {c.phone}</div>}
                  {c.email && <div>Email: {c.email}</div>}
                </li>
              ))}
            </ul>
          </div>
          <div className="mb-4">
            <Standings seasonId={seasonId} selectedTeamId={Number(teamId)} />
          </div>
          <div>
            <Matches seasonId={seasonId} filterTeamId={Number(teamId)} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default TeamDetail;
